export async function magicLogin(payload) {
  const res = await fetch('/api/auth/magiclogin', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const body = await res.json();
  return body;
}

export async function signup(payload) {
  const res = await fetch('/api/auth/signup', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  });
  const body = await res.json();
  if (res.ok) {
    return body;
  } else {
    if (body.name === 'EmailAlreadyExistsError') {
      const error = new Error(
        'Er bestaat al een gebruiker met dit e-mailadres'
      );
      throw error;
    }
    const error = new Error(body.message);
    error.name = body.name;
    throw error;
  }
}
